import React from "react";
import HomeNav from "../components/landingPage/HomeNav";
import HomeHero from "../components/landingPage/HomeHero";
import HomeProduct from "../components/landingPage/HomeProduct";
import HomeGoogleCompliance from "../components/landingPage/HomeGoogleCompliance";
import HomePricing from "../components/landingPage/HomePricing";
import HomeAbout from "../components/landingPage/HomeAbout";
import HomeTestimonials from "../components/landingPage/HomeTestimonials";
import HomeContactUs from "../components/landingPage/HomeContactUs";
import HomeFooter from "../components/landingPage/HomeFooter";
import { useNavigate } from "react-router-dom";
import  secureLocalStorage  from  "react-secure-storage";

const Home = () => {
  const navigate = useNavigate();
  /**
   * if user is already logged in then redirect to dashboard,
   * instead of returning the login page
   */
  if (secureLocalStorage.getItem("token")) {
    navigate("/dashboard");
  }
  return (
    <div>
      <HomeNav />
      <HomeHero />
      <HomeGoogleCompliance />
      <HomeProduct />
      <HomePricing />
      <HomeAbout />
      <HomeTestimonials />
      <HomeContactUs />
      <HomeFooter />
    </div>
  );
};

export default Home;
